import React, { FC } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Theme, Typography } from '@material-ui/core';

interface PrivacyContentProps {
  title?: string;
  listItems: string[];
}

const useStyles = makeStyles((theme: Theme) => ({
  title: {
    fontWeight: 600,
    fontSize: 32,
    color: theme.palette.primary.main,
    marginTop: 24,
    marginBottom: 24,
  },
  description: {
    paddingBottom: 1,
  },
  text: {
    fontWeight: 600,
    fontSize: 18,
    marginBottom: 18,
  },
}));

const Content: FC<PrivacyContentProps> = ({ title, listItems = [] }) => {
  const styles = useStyles();

  return (
    <>
      <Typography className={styles.title}>{title}</Typography>
      <Grid className={styles.description}>
        {listItems.map((item, index) => (
          <Typography key={index} className={styles.text}>
            {item}
          </Typography>
        ))}
      </Grid>
    </>
  );
};

export default Content;
